import { Accordion, AccordionTab } from "primereact/accordion";
import React, { useRef } from "react";
import TaxData from "./TaxData";
import DeliveryFeeData from "./DeliveryFeeData";
import './printInvoice.css'
import { BsTelephone } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";

const PrintInvoice = ({deliveryDetails,vendorDetails, details, index }) => {

  const componentRef = useRef();

  
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current, // Specifies the content to print
//     documentTitle: `Invoice_${index}`, // Optional: Sets the title of the PDF
//     pageStyle: `
//       @media print {
//         body {
//           font-family: Arial, sans-serif;
//           margin: 0;
//           padding: 20px;
//         }
//         .accordion-tab-header {
//           font-weight: bold;
//           font-size: 18px;
//           margin-bottom: 10px;
//         }
//       }
//     `, 
//   });
const handlePrint = () => {
    console.log("componentRef.current", componentRef.current);
    if (componentRef.current) {
      const printableContent = componentRef.current.innerHTML;
      const printWindow = window.open("", "_blank");
  
      // Creating the HTML for the print window with internal styles and Tailwind CSS
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Invoice</title>
            <style>
             @media print {
  body {
    font-family: Arial, sans-serif;
  }
  .printable {
    width: 210mm;
    margin: 0 auto;
    background: #fff;
    padding: 10px;
    box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f3f3f3;
  }

  .text-center {
    text-align: center;
  }

  .font-bold {
    font-weight: bold;
  }

  .logo {
    height: 50px;
    width: 50px;
    background: url('../../../../../public/logo.png') no-repeat center;
    background-size: contain;
  }

  #top .info h2 {
    margin: 0;
    font-size: 1.2em;
  }

  #top {
    margin-bottom: 10px;
  }

  #bot {
    margin-top: 10px;
  }

  #bot td, #bot th {
    font-size: 0.8em;
  }
}

            </style>
          </head>
          <body>
            ${printableContent}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Ref is not available");
    }
  };
  

  
  
  return (
    <div>
      {/* Customer Details */}
     {deliveryDetails?( <div className="mb-6">
        <h3 className="font-semibold mb-2 text-lg">Order by</h3>
        <p className="text-2xl font-semibold hover:text-blue-900 transition duration-300">
          {deliveryDetails?.name ?? "N/A"}
        </p>
        <div className="flex justify-between items-center mt-1">
          <p className="text-gray-500 text-2xl hover:text-blue-900 transition duration-300">
            {deliveryDetails?.phone_number ?? "N/A"}
          </p>
          <BsTelephone className="text-2xl text-blue-900 hover:text-blue-700 transition duration-300" />
        </div>

        <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
          <CiLocationOn className="text-3xl text-blue-900" />
          <p className="text-gray-700">
            {deliveryDetails?.flat_no ?? "N/A"},{" "}
            {deliveryDetails?.landmark ?? "N/A"},
            {deliveryDetails?.street ?? "N/A"},{" "}
            {deliveryDetails?.pin_code ?? "N/A"}
          </p>
        </div>
        {/* <p className="text-gray-500 text-sm mt-2">2.90 Km, 8.75 Min</p>
                <p className="text-gray-700 mt-3 font-medium">Order for</p> */}
        {/* <p className="text-gray-700 mt-4 text-xl hover:text-blue-900 transition duration-300">
                  {deliveryDetails?.name ?? "N/A"}
                </p> */}
      </div>):''}

      {vendorDetails?<div>        
          <h3 className="font-semibold mb-2 text-lg">Vendor Details</h3>      
          <p className="text-2xl font-semibold hover:text-blue-900 transition duration-300">
          {vendorDetails?.first_name || ""}
        </p>
          <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
          <CiLocationOn className="text-3xl text-blue-900" />
          <p className="text-gray-700">
            {vendorDetails?.address ?? "N/A"},{" "}          
          </p>
        </div>
        </div>:""}
      {/* Component content to print */}
      <Accordion multiple activeIndex={[index]}>
        <AccordionTab
          header={
            <p className="text-lg font-bold my-4 accordion-tab-header">
              Invoice
            </p>
          }
        >
          <div ref={componentRef}>          

            <TaxData
              key={`${index}t`}
              item={details?.product?.product_details}
              ProductDeatils={details}
              deliveryDetails={deliveryDetails}
              vendorDetails={vendorDetails}
            />
            <DeliveryFeeData  ProductDeatils={details} key={`${index}d`} data={details?.delivery_fee} />
          </div>
        </AccordionTab>
      </Accordion>

      {/* Print button */}
      <button onClick={handlePrint} className="px-4 py-2 my-4 btn">
        Print as PDF
      </button>
    </div>
  );
};

export default PrintInvoice;
